@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.wouip

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import pl.finn.forms.Zalacznik

@Serializable
data class WouipForm(
    var temat: String? = null,
    var miejscowoscDokumentu: String? = null,
    var zakres: String? = null,
    var sposobUdostepnienia: SposobUdostepnienia = SposobUdostepnienia(),
    var formaUdostepnienia: FormaUdostepnienia = FormaUdostepnienia(),
    var oswiadczenia:  ArrayList<Oswiadczenia> = arrayListOf<Oswiadczenia>(),
    var informacjeDodatkowe:  ArrayList<InformacjeDodatkowe> = arrayListOf<InformacjeDodatkowe>(),
    var podpis: Podpis = Podpis(),

)

@Serializable
data class WouipFormData(
    val form: WouipForm,
    val zalaczniki: List<Zalacznik>,
    val url: String,
    val token: String?
)
@Serializable
data class SposobUdostepnienia(
    var sposob: String? = null,
    var wartosc: String? = null
)
@Serializable
data class FormaUdostepnienia(
    var adres: Adres = Adres(),
    var forma: String? = null,
    var wartosc: String? = null

)
@Serializable
data class Oswiadczenia(
    var oswiadczenie: String? = null
)
@Serializable
data class InformacjeDodatkowe(
    var informacja: String? = null
)
@Serializable
data class Adres(
    var wlasny: Boolean = false,
    var nazwa: String? = null,
    var kodPocztowy: String? = null,
    var poczta: String? = null,
    var miejscowosc: String? = null,
    var ulica: String? = null,
    var budynek: String? = null,
    var lokal: String? = null,
)
@Serializable
data class Podpis(
    var zUpowaznienia: String? = null,
    var imieNazwiskoGrupa: ImieNazwiskoGrupa = ImieNazwiskoGrupa(),
    var stanowisko: String? = null,
)
@Serializable
data class ImieNazwiskoGrupa(
    var imie: String? = null,
    var imieDrugie: String? = null,
    var nazwisko: String? = null,
    var nazwiskoCzlonPierwszy: String? = null,
    var nazwiskoCzlonDrugi: String? = null,
    var nazwiskoCzlonTrzeci: String? = null
)